import { types, actions } from './requests'
export const GETLASTGT2000DATA_TYPES = {
    ...types('GETLASTGT2000DATA'),
}
export const GETLASTGT2000DATA_ACTIONS = {
    ...actions('GETLASTGT2000DATA'),
}
